var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmptyFrame = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M76 43.322c0 5.153-3.793 4.666-8.47 4.666H12.47c-4.677 0-8.47.487-8.47-4.666l4.235-27.991C8.5 10.859 12.028 6 16.705 6h46.59c4.677 0 8.027 5.15 8.47 9.33L76 43.323Z",
  fill: "#67757F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M76 67.53A8.47 8.47 0 0 1 67.53 76H12.47A8.47 8.47 0 0 1 4 67.53V44.234a8.471 8.471 0 0 1 8.47-8.47h55.06a8.471 8.471 0 0 1 8.47 8.47V67.53Z",
  fill: "#9AAAB4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.824 61.176a4.237 4.237 0 0 1-4.236 4.236H29.412a4.237 4.237 0 0 1-4.235-4.236V50.588a4.237 4.237 0 0 1 4.235-4.235h21.176a4.237 4.237 0 0 1 4.236 4.235v10.588Z",
  fill: "#67757F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.588 59.059a2.116 2.116 0 0 1-2.117 2.117H31.529a2.117 2.117 0 0 1-2.117-2.117v-6.353c0-1.171.948-2.118 2.117-2.118h16.942c1.17 0 2.117.947 2.117 2.118v6.353Z",
  fill: "#E1E8ED"
})));

export default SvgEmptyFrame;